import { makeStyles } from '@material-ui/core/styles';
import { Alert } from '@material-ui/lab';

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(1),
  },
}));

export interface ModelFallbackNoticeProps {
  /** Aviso vindo do worker; ausente = nada a mostrar. */
  message?: string;
  onClose: () => void;
}

/**
 * Aviso de que a fase roda em `auto` porque o modelo escolhido não é liberado
 * pela conta GitHub Copilot (iniciativa `copilot-modelos-da-conta`, D-CMC-3).
 * É aviso, não erro: a fase segue normalmente.
 */
export function ModelFallbackNotice({
  message,
  onClose,
}: ModelFallbackNoticeProps) {
  const classes = useStyles();
  if (!message) {
    return null;
  }
  return (
    <Alert severity="warning" onClose={onClose} className={classes.root}>
      {message}
    </Alert>
  );
}
